export class ContentLibraryType {
	Id: number;
	Name: string;

	name: string;
}